/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { GiftconDetailDto } from '../models/GiftconDetailDto';
import type { PaginatedGiftconListDto } from '../models/PaginatedGiftconListDto';

import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';

export class GiftconsService {
  /**
   * 보유 기프티콘 목록 조회
   * @returns PaginatedGiftconListDto
   * @throws ApiError
   */
  public static giftconControllerFindAllWithPaginationByUser({
    page = 1,
    itemsPerPage = 30,
  }: {
    page?: number;
    itemsPerPage?: number;
  }): CancelablePromise<PaginatedGiftconListDto> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/me/giftcons',
      query: {
        page: page,
        itemsPerPage: itemsPerPage,
      },
    });
  }

  /**
   * 보유 기프티콘 상세 조회
   * @returns GiftconDetailDto
   * @throws ApiError
   */
  public static giftconControllerFindOneByIdWithUpdatedStatus({
    giftconId,
  }: {
    giftconId: number;
  }): CancelablePromise<GiftconDetailDto> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/giftcons/{giftconId}',
      path: {
        giftconId: giftconId,
      },
    });
  }

  /**
   * 보유 기프티콘 쿠폰 이미지 조회
   * @returns any
   * @throws ApiError
   */
  public static giftconControllerGetCouponImage({
    giftconId,
  }: {
    giftconId: number;
  }): CancelablePromise<any> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/giftcons/{giftconId}/coupon-image',
      path: {
        giftconId: giftconId,
      },
    });
  }
}
